<template>
    <el-card>
        <div slot="header" class="clearfix">
            <div class="title">询盘星</div>
            <div v-if="pageType=='公海'" style="display: flex;gap: 20px;">
                <el-input v-model="public_search.company" clearable @keyup.enter.native="onPublicSearch" placeholder="公司" class="searchItem" size="small"></el-input>
                <el-select v-model="public_search.country" clearable filterable placeholder="国家" class="searchItem" size="small" @change="onPublicSearch">
                    <el-option v-for="item in publicCountryOption" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disable">
                        <img v-if="item.flagUrl" :src="item.flagUrl" style="height: 14px;margin-right: 6px;" />
                        <span>{{item.label}}</span>
                        <span>({{item.count}})</span>
                    </el-option>
                </el-select>
                <el-select v-model="public_search.industry" clearable filterable placeholder="行业" class="searchItem" size="small" @change="onPublicSearch">
                    <el-option-group v-for="group in industryOption" :key="group.key" :label="group.label">  
                    <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disable">
                        <span>{{item.label}}</span>
                        <span>({{item.count}})</span>
                    </el-option>
                    </el-option-group>
                </el-select>
                <el-input v-model="public_search.product" clearable @keyup.enter.native="onPublicSearch" placeholder="产品" class="searchItem" size="small"></el-input>
            </div>
            <div style="margin-left: auto;" v-if="pageType=='公海'">
                <el-button style="width:100px;margin-left: auto;" type="primary" size="small" icon="el-icon-search" @click="onPublicSearch">搜 索</el-button>
            </div>
            <div v-if="pageType=='私海'">
                <el-date-picker v-model="searchForm.startDate" type="date" size="small" placeholder="开始日期" value-format="yyyy-MM-dd" @change="onSearch" style="width: 180px;">
                </el-date-picker>
                <span style="font-size: 14px;margin: 0 10px;">至</span>
                <el-date-picker v-model="searchForm.endDate" type="date" size="small" placeholder="结束日期" value-format="yyyy-MM-dd" @change="onSearch" style="width: 180px;">
                </el-date-picker>
            </div>
            <div style="margin-left: auto;" v-if="pageType=='私海'">
                <el-link href="/#/openDoc?active=GetInquiryList" target="_blank">对接开放平台</el-link>
                <el-button @click="setTip" size="small" style="margin-left: 20px;">设置提醒</el-button>
                <el-button v-if="isAdmin" @click="toAllocate" size="small">分配线索</el-button>
            </div>
        </div>
        <div style="display: flex;">
            <div class="leftFilter">
                <div class="title" :class="{'activeTitle': pageType=='公海'}" @click="viewHighseas">
                    <span>公海</span>
                </div>
                <div class="title">
                    <span>阶段</span>
                    <span><i class="el-icon-plus" @click.stop="addPhase" v-if="isAdmin"></i></span>
                </div>
                <div>
                    <div class="phaseItem" :class="{'activePhase':searchForm.phase == ''}" @click="choosePhase('')">
                        <div>
                            <span>全部</span>
                            <span style="font-size: 14px;padding-left: 5px;">({{ phaseTotalNum || "无" }})</span>
                        </div>
                    </div>
                    <div class="phaseItem" v-for="item in allPhaseOption" :key="item.key"
                    :class="{'activePhase':searchForm.phase == item.name}" @click="choosePhase(item.name)">
                        <div>
                            <span>{{ item.name }}</span>
                            <span style="font-size: 14px;padding-left: 5px;">({{ item.count || "无" }})</span>
                        </div>
                        <!-- 非系统可删除 -->
                        <i class="el-icon-delete" v-if="!item.system && isAdmin" @click.stop="delPhase(item.key)"></i>
                    </div>
                </div>
            </div>
            <div class="rightContent" v-if="pageType=='公海'">
                <div style="margin-bottom: 12px;display: flex;align-items: center;">
                    <el-checkbox v-model="public_search.isPhone" @change="onPublicSearch">有号码</el-checkbox>
                    <el-checkbox v-model="public_search.isEmail" @change="onPublicSearch">有邮箱</el-checkbox>
                    <!-- 1近一个月 2近三个月 3近半年 4近一年 0全部 -->
                    <span style="padding: 0 8px;"></span>
                    <el-select v-model="public_search.date" size="small" style="width: 150px;" @change="onPublicSearch">
                        <el-option label="近一个月" :value="1"></el-option>
                        <el-option label="近三个月" :value="2"></el-option>
                        <el-option label="近半年" :value="3"></el-option>
                        <el-option label="近一年" :value="4"></el-option>
                        <el-option label="全部" :value="0"></el-option>
                    </el-select>
                </div>
                <div v-loading="tableLoading">
                    <el-empty v-if="public_totalItems==0" description="暂无数据" style="height:calc(100vh - 300px);"></el-empty>
                    <div v-else style="height:calc(100vh - 300px);overflow: auto;">
                        <div class="public_ad_item" v-for="(item,index) in public_adList" :key="index">
                            <div v-if="item.imgUrl.length">
                                <el-image :src="item.imgUrl[0]" :preview-src-list="item.imgUrl" style="width: 100px; height: 100px;" />
                            </div>
                            <div v-else style="width: 100px; height: 100px;display: flex;align-items: center;justify-content: center;">
                                <i class="el-icon-picture" style="font-size: 88px;color: #cdcdcd;"></i>
                            </div>
                            <div class="rightInfo" @click="openDetails(item)">
                                <div style="width: 30%;display: flex;flex-direction: column;justify-content: space-between;">
                                    <div style="height: 24px;display:flex;align-items:center;">
                                        <div style="color: #333;font-weight: 500;cursor: pointer;">
                                            {{ item.company }}
                                        </div>
                                        <div style="display:flex;align-items:center;font-size:14px;margin-left:12px;">
                                            <img v-if="item.flagUrl" :src="item.flagUrl" style="height:14px;margin-right:6px;" />
                                            <span>{{ item.country }}</span>
                                        </div>
                                    </div>
                                    <div style="display: flex;align-items: center;">
                                        <div style="height: 24px;line-height: 24px;border-radius: 2px;border: 1px solid #DDE0E9;color: #6B6F80;font-size: 12px;padding: 0 6px;">
                                            行业：{{ item.industry || "--" }}
                                        </div>
                                    </div>
                                    <div class="fieldItem">
                                        <div class="fieldlabel">询盘时间</div>
                                        <div class="fieldvalue utils-omit-1">
                                            {{ item.inquiryDate || "--" }}
                                        </div>
                                    </div>
                                </div>
                                <div style="width: 50%;">
                                    <div style="font-size: 14px;color: #9a9a9a;">采购需求</div>
                                    <div style="margin-top: 8px;display: flex;justify-content: center;">
                                        <div class="fieldItem">
                                            <!-- <div class="fieldlabel">产品</div> -->
                                            <div class="fieldvalue utils-omit-2" :title="item.product">
                                                {{ item.product || "--" }}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="margin-top: 8px;display: flex;justify-content: center;">
                                        <div class="fieldItem">
                                            <!-- <div class="fieldlabel">描述</div> -->
                                            <div class="fieldvalue utils-omit-2" :title="item.description">
                                                {{ item.description || "--" }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="width: 20%;">
                                    <div style="display: flex;align-items: center;">
                                        <el-button style="margin-left: auto;" type="primary" size="small" plain :disabled="isDemoAccount" @click.stop="addMyClue(item)">
                                            <i class="el-icon-plus"></i><span>加入我的询盘</span>
                                        </el-button>
                                    </div>
                                    <div style="display: flex;align-items: center;margin-top: 12px;">
                                        <el-select style="width: 120px;margin-left: auto;" v-if="isAdmin" :disabled="isDemoAccount" v-model="item.ownerKey" size="small" filterable @change="(value)=>allocateClue(value,item)">
                                            <el-option label="待分配" value="" disabled></el-option>
                                            <el-option v-for="item in staffOption" :key="item.key" :label="item.name" :value="item.key"></el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <el-table v-else :data="public_adList" style="width:100%;" height="calc(100vh - 320px)" size="small" @row-click="openDetails">
                        <el-table-column prop="country" label="国家" width="120px">
                            <template slot-scope="scope">
                                <div style="display:flex;align-items:center">
                                    <img v-if="scope.row.flagUrl" :src="scope.row.flagUrl" style="height: 14px;margin-right: 4px;" />
                                    <span>{{scope.row.country}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" width="100px"></el-table-column>
                        <el-table-column prop="email" label="邮箱" width="200px"></el-table-column>
                        <el-table-column prop="phone" label="手机号" width="100px"></el-table-column>
                        <el-table-column prop="company" label="公司" width="120px" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="product" label="产品" width="150px"></el-table-column>
                        <el-table-column prop="description" label="描述" width="300px" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="industry" label="行业" width="120px"></el-table-column>
                        <el-table-column prop="source" label="来源" width="120px"></el-table-column>
                        <el-table-column prop="inquiryDate" label="询盘时间" width="150px"></el-table-column>
                        <el-table-column label="分配" width="150px" fixed="right" v-if="isAdmin">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.ownerKey" size="small" filterable @change="(value)=>allocateClue(value,scope.row)">
                                    <el-option label="待分配" value="" disabled></el-option>
                                    <el-option v-for="item in staffOption" :key="item.key" :label="item.name" :value="item.key"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120px" fixed="right">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click.stop="addMyClue(scope.row)">加入我的询盘</el-link>
                            </template>
                        </el-table-column>
                    </el-table> -->
                    <div style="height: 32px;display: flex;align-items: center; justify-content: space-between;margin-top: 12px;">
                        <div style="display: flex;gap: 20px;font-size: 14px;color: #3a3a3a;">
                            <span><em class="commonColor">{{ publicCountryOption.length }}</em> 个国家</span>
                            <span><em class="commonColor">{{ public_totalItems }}</em> 个询盘</span>
                            <span><em class="commonColor">{{ industryNumber }}</em> 个行业</span>
                            <span v-if="follow_totalItems" style="cursor: pointer;" @click="followVisible = true;">
                                已跟进询盘(<em class="commonColor">{{ follow_totalItems }}个</em>)
                            </span>
                        </div>
                        <el-pagination hide-on-single-page background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 40]" :page-size.sync="public_pageSize" @size-change="publicPageSizeChange" :total="public_totalItems" small :current-page.sync="public_pageIndex" @current-change="publicPageIndexChange"></el-pagination>
                    </div>
                </div>
            </div>
            <div class="rightContent" v-if="pageType=='私海'">
                <el-form label-width="60px" :inline="true" size="small" label-position="left">
                    <el-row :gutter="16">
                        <el-col :span="6">
                            <el-form-item label="姓名">
                                <el-input v-model="searchForm.name" @keyup.enter.native="onSearch" placeholder="姓名" class="searchItem"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="邮箱">
                                <el-input v-model="searchForm.email" @keyup.enter.native="onSearch" placeholder="邮箱" class="searchItem"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="手机号">
                                <el-input v-model="searchForm.phone" @keyup.enter.native="onSearch" placeholder="手机号" class="searchItem"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="国家">
                                <el-select v-model="searchForm.country" clearable filterable placeholder="国家" class="searchItem" @change="onSearch">
                                    <el-option v-for="item in countryOption" :key="item" :label="item" :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="状态">
                                <el-select v-model="searchForm.stutas" class="searchItem" @change="onSearch">
                                    <el-option label="全部" :value="null"></el-option>
                                    <el-option label="待分配" :value="0"></el-option>
                                    <el-option label="已分配" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="来源">
                                <el-select v-model="searchForm.formName" clearable filterable placeholder="来源" class="searchItem" @change="onSearch">
                                    <el-option v-for="item in formOption" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="分配">
                                <el-select v-model="searchForm.ownerKey" clearable filterable placeholder="分配" class="searchItem" @change="onSearch">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in staffOption" :key="item.key" :label="item.name" :value="item.key"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-button style="width:100px;" type="primary" size="small" icon="el-icon-search" @click="onSearch">搜 索</el-button>
                            <el-button style="width:100px;" size="small" @click="onReset">重 置</el-button>
                        </el-col>
                        <!-- <el-col :span="6">
                            <el-form-item label="阶段">
                                <el-select v-model="searchForm.phase" clearable filterable placeholder="阶段" class="searchItem" @change="onSearch">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in allPhaseOption" :key="item.key" :label="item.name" :value="item.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                </el-form>
                <div v-loading="tableLoading">
                    <el-empty v-if="totalItems==0" description="暂无数据" style="height:calc(100vh - 350px);"></el-empty>
                    <el-table v-else :data="advertisingList" style="width:100%;" height="calc(100vh - 350px)" size="small" @row-click="displayPanelOne">
                        <el-table-column prop="country" label="国家" width="120px">
                            <template slot-scope="scope">
                                <div style="display:flex;align-items:center">
                                    <img v-if="scope.row.flagUrl" :src="scope.row.flagUrl" style="height: 14px;margin-right: 4px;" />
                                    <span>{{scope.row.country}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" min-width="120px"></el-table-column>
                        <el-table-column prop="email" label="邮箱" min-width="200px"></el-table-column>
                        <el-table-column prop="phone" label="手机号" min-width="120px"></el-table-column>
                        <el-table-column prop="company" label="公司" width="200px" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="formName" label="来源" width="200px" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="createdTime" label="提交时间" width="150px"></el-table-column>

                        <el-table-column label="线索内容" width="300px">
                            <template slot-scope="scope">
                                <div v-if="scope.row.json">
                                    <el-tooltip effect="dark" placement="bottom-end">
                                        <div slot="content">
                                            <div style="line-height: 20px;" v-for="(value,key) in JSON.parse(scope.row.json)">
                                                {{ key }}: {{ value }}
                                            </div>
                                        </div>
                                        <div class="ellipsis">
                                            <span style="margin-right: 10px;" v-for="(value,key) in JSON.parse(scope.row.json)">
                                                {{ key }}: {{ value }}
                                            </span>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="分配" width="150px" fixed="right" v-if="isAdmin">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.ownerKey" size="small" filterable @change="(value)=>allocateChange(value,scope.row.key)">
                                    <el-option label="待分配" value="" disabled></el-option>
                                    <el-option v-for="item in staffOption" :key="item.key" :label="item.name" :value="item.key"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="阶段" width="150px" fixed="right">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.phase" size="small" @change="(value)=>phaseChange(value,scope.row.key)">
                                    <el-option v-for="item in basePhaseOption" :key="item.key" :label="item.name" :value="item.name"
                                    :disabled="item.name=='垃圾-客户'"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="180px" fixed="right">
                            <template slot-scope="scope">
                                <span v-if="scope.row.addCustomer">已加入我的客户</span>
                                <el-link v-else type="primary" :underline="false" @click.stop="addCustomer(scope.row)">加入我的客户</el-link>
                                <span style="padding: 0 8px;">|</span>
                                <el-link type="info" :underline="false" @click.stop="delClue(scope.row.key)">删除</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination hide-on-single-page background layout="total, sizes, prev, pager, next" :page-sizes="[10, 20, 40]" :page-size.sync="pageSize" @size-change="pageSizeChange" :total="totalItems" small style="float: right; margin: 10px 0" :current-page.sync="pageIndex" @current-change="pageIndexChange"></el-pagination>
                </div>
            </div>
        </div>

        <el-dialog title="已跟进询盘" :visible.sync="followVisible" width="1200px" top="50px">
            <div style="display: flex;gap: 20px;margin-bottom: 12px;">
                <el-input v-model="follow_search.company" clearable @keyup.enter.native="onFollowSearch" placeholder="公司" class="searchItem" size="small"></el-input>
                <el-select v-model="follow_search.country" clearable filterable placeholder="国家" class="searchItem" size="small" @change="onFollowSearch">
                    <el-option v-for="item in publicCountryOption" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disable">
                        <img v-if="item.flagUrl" :src="item.flagUrl" style="height: 14px;margin-right: 6px;" />
                        <span>{{item.label}}</span>
                        <span>({{item.count}})</span>
                    </el-option>
                </el-select>
                <el-select v-model="follow_search.industry" clearable filterable placeholder="行业" class="searchItem" size="small" @change="onFollowSearch">
                    <el-option-group v-for="group in industryOption" :key="group.key" :label="group.label">  
                    <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disable">
                        <span>{{item.label}}</span>
                        <span>({{item.count}})</span>
                    </el-option>
                    </el-option-group>
                </el-select>
                <el-input v-model="follow_search.product" clearable @keyup.enter.native="onFollowSearch" placeholder="产品" class="searchItem" size="small"></el-input>
                <el-button style="width:100px;margin-left: auto;" type="primary" size="small" icon="el-icon-search" @click="onFollowSearch">搜 索</el-button>
            </div>
            <div style="margin-bottom: 12px;display: flex;align-items: center;">
                <el-checkbox v-model="follow_search.isPhone" @change="onFollowSearch">有号码</el-checkbox>
                <el-checkbox v-model="follow_search.isEmail" @change="onFollowSearch">有邮箱</el-checkbox>
                <!-- 1近一个月 2近三个月 3近半年 4近一年 0全部 -->
                <span style="padding: 0 8px;"></span>
                <el-select v-model="follow_search.date" size="small" style="width: 150px;" @change="onFollowSearch">
                    <el-option label="近一个月" :value="1"></el-option>
                    <el-option label="近三个月" :value="2"></el-option>
                    <el-option label="近半年" :value="3"></el-option>
                    <el-option label="近一年" :value="4"></el-option>
                    <el-option label="全部" :value="0"></el-option>
                </el-select>
                <span style="padding: 0 8px;"></span>
                <el-select v-model="follow_search.ownerKey" size="small" clearable filterable style="width: 150px;" @change="onFollowSearch">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in staffOption" :key="item.key" :label="item.name" :value="item.key"></el-option>
                </el-select>
            </div>
            <el-empty v-if="follow_totalItems==0" description="暂无数据" style="height:calc(100vh - 300px);"></el-empty>
            <div v-else style="height:calc(100vh - 300px);overflow: auto;">
                <div class="public_ad_item" v-for="(item,index) in follow_adList" :key="index">
                    <div v-if="item.imgUrl.length">
                        <el-image :src="item.imgUrl[0]" :preview-src-list="item.imgUrl" style="width: 100px; height: 100px;" />
                    </div>
                    <div v-else style="width: 100px; height: 100px;display: flex;align-items: center;justify-content: center;">
                        <i class="el-icon-picture" style="font-size: 88px;color: #cdcdcd;"></i>
                    </div>
                    <div class="rightInfo" @click="displayPanelTwo(item)">
                        <div style="width: 30%;display: flex;flex-direction: column;justify-content: space-between;">
                            <div style="height: 24px;display:flex;align-items:center;">
                                <div style="color: #333;font-weight: 500;cursor: pointer;">
                                    {{ item.company }}
                                </div>
                                <div style="display:flex;align-items:center;font-size:14px;margin-left:12px;">
                                    <img v-if="item.flagUrl" :src="item.flagUrl" style="height:14px;margin-right:6px;" />
                                    <span>{{ item.country }}</span>
                                </div>
                            </div>
                            <div style="display: flex;align-items: center;">
                                <div style="height: 24px;line-height: 24px;border-radius: 2px;border: 1px solid #DDE0E9;color: #6B6F80;font-size: 12px;padding: 0 6px;">
                                    行业：{{ item.industry || "--" }}
                                </div>
                            </div>
                            <div class="fieldItem">
                                <div class="fieldlabel">询盘时间</div>
                                <div class="fieldvalue utils-omit-1">
                                    {{ item.inquiryDate || "--" }}
                                </div>
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div style="font-size: 14px;color: #9a9a9a;">采购需求</div>
                            <div style="margin-top: 8px;display: flex;justify-content: center;">
                                <div class="fieldItem">
                                    <!-- <div class="fieldlabel">产品</div> -->
                                    <div class="fieldvalue utils-omit-2" :title="item.product">
                                        {{ item.product || "--" }}
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 8px;display: flex;justify-content: center;">
                                <div class="fieldItem">
                                    <!-- <div class="fieldlabel">描述</div> -->
                                    <div class="fieldvalue utils-omit-2" :title="item.description">
                                        {{ item.description || "--" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 20%;">
                            <div style="display: flex;align-items: center;">
                                <div class="fieldItem">
                                    <div class="fieldlabel">添加人</div>
                                    <div class="fieldvalue utils-omit-1">
                                        {{ item.createNmae || "--" }}
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;align-items: center;margin-top: 12px;">
                                <div class="fieldItem">
                                    <div class="fieldlabel">跟进人</div>
                                    <div class="fieldvalue utils-omit-1">
                                        {{ item.owner || "--" }}
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;align-items: center;margin-top: 12px;">
                                <div class="fieldItem">
                                    <div class="fieldlabel">添加时间</div>
                                    <div class="fieldvalue utils-omit-1">
                                        {{ item.createTime || "--" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex;justify-content: space-between;margin-top: 8px;">
                <span></span>
                <!-- hide-on-single-page -->
                <el-pagination background layout="prev, pager, next" :page-size.sync="follow_pageSize" :total="follow_totalItems" small :current-page.sync="follow_pageIndex" @current-change="getFollowInquiry"></el-pagination>
            </div>
        </el-dialog>

        <!-- 公海详情面板 -->
        <el-drawer :visible.sync="detailsVisible" :with-header="false" :size="550" @close="detailsVisible = false;" destroy-on-close>
            <div style="padding: 0 30px;">
                <div style="padding: 20px 0;">
                    <img @click="detailsVisible = false;" src="@/assets/img/goback.png" style="cursor: pointer" />
                </div>
                <div style="height: 24px;display:flex;align-items:center;margin-bottom: 10px;">
                    <div style="color: #111827;font-weight: 500;">
                        {{ detailsInfo.company }}
                    </div>
                    <div style="display:flex;align-items:center;font-size: 14px;margin-left: 12px;">
                        <img v-if="detailsInfo.flagUrl" :src="detailsInfo.flagUrl" style="height: 14px;margin-right: 6px;" />
                        <span>{{ detailsInfo.country }}</span>
                    </div>
                </div>
                <el-button type="primary" size="small" plain @click.stop="addMyClue(detailsInfo)">
                    <i class="el-icon-plus"></i><span>加入我的询盘</span>
                </el-button>
                <div style="margin-top: 20px;"></div>
                <div class="abtitle">联系方式</div>
                <div class="abItem">
                    <div class="label">姓名:</div>
                    <div class="value">{{ detailsInfo.name || "--" }}</div>
                </div>
                <div class="abItem">
                    <div class="label">手机:</div>
                    <div class="value">{{ detailsInfo.phone || "--" }}</div>
                </div>
                <div class="abItem">
                    <div class="label">邮箱:</div>
                    <div class="value">{{ detailsInfo.email || "--" }}</div>
                </div>
                <div class="abtitle">采购需求</div>
                <div class="abItem">
                    <div class="label">时间:</div>
                    <div class="value">{{ detailsInfo.inquiryDate || "--" }}</div>
                </div>
                <div class="abItem">
                    <div class="label">需求:</div>
                    <div class="value">{{ detailsInfo.product || "--" }}</div>
                </div>
                <div class="abItem">
                    <div class="label"></div>
                    <div class="value">{{ detailsInfo.description || "--" }}</div>
                </div>
                <div class="abItem">
                    <div class="label">行业:</div>
                    <div class="value">{{ detailsInfo.industry || "--" }}</div>
                </div>
                <div class="abtitle" v-if="detailsInfo.imgUrl.length || detailsInfo.videoUrl.length">
                    图片/视频
                </div>
                <div class="abItem" v-if="detailsInfo.imgUrl.length">
                    <div class="label">图片:</div>
                    <div style="display: flex;gap: 12px;flex-wrap: wrap;">
                        <div v-for="(item,index) in detailsInfo.imgUrl" :key="index">
                            <el-image :src="item" :preview-src-list="detailsInfo.imgUrl" style="width: 100px; height: 100px;" />
                        </div>
                    </div>
                </div>
                <div class="abItem" v-if="detailsInfo.videoUrl.length">
                    <div class="label">视频:</div>
                    <div v-for="(item,index) in detailsInfo.videoUrl" :key="index">
                        <video :src="item" style="width: 400px; height: 240px;" controls></video>
                    </div>
                </div>
                <div class="abtitle">更多信息</div>
                <div class="abItem">
                    <div class="label">来源:</div>
                    <div class="value">{{ detailsInfo.source || "--" }}</div>
                </div>
            </div>
        </el-drawer>  

        <el-dialog title="分配线索" :visible.sync="allocateVisible" width="450px">
            <el-form :model="allocateForm" label-width="50px" size="small">
                <!-- <el-form-item label="表单:">
                    <el-select v-model="allocateForm.formId" clearable filterable placeholder="选择表单" style="width:100%;">
                        <el-option v-for="item in formOption" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disable"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="国家:">
                    <el-select v-model="allocateForm.country" allow-create clearable filterable placeholder="选择国家" style="width:100%;">
                        <el-option v-for="item in countryOption" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="渠道:">
                    <el-input v-model="allocateForm.platform" clearable></el-input>
                </el-form-item> -->
                <el-form-item label="员工:">
                    <el-select v-model="allocateForm.ukey" size="small" clearable filterable placeholder="选择员工" style="width:100%;">
                        <el-option v-for="item in staffOption" :key="item.key" :label="item.name" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="allocateVisible = false;" size="small">取 消</el-button>
                <el-button type="primary" @click="allocateComplete" :loading="btnLoading" size="small">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 私海详情面板 -->
        <el-drawer :visible.sync="panelVisible" :with-header="false" :size="550" @close="closePanel" destroy-on-close>
            <div style="padding: 0 30px;">
                <div style="padding: 20px 0;">
                    <img @click="closePanel" src="@/assets/img/goback.png" style="cursor: pointer" />
                </div>
                <div style="display: flex; margin-bottom: 5px;">
                    <div style="margin-right: 20px">
                        <img src="@/assets/img/customerFace.png" style="vertical-align: bottom" />
                    </div>
                    <div>
                        <div style="display: flex; align-items: center;height: 24px;margin-bottom: 4px;">
                            <p style="font-size: 20px;margin-right: 12px;">{{ customerInfo.name }}</p>
                            <img :src="customerInfo.flagUrl" style="height: 14px;margin-right: 4px;" />
                            <span style="font-size: 14px; color: #1a2745;">{{ customerInfo.country }}</span>
                        </div>
                        <div style="display: flex; align-items: center;gap: 12px;font-size: 14px;height: 22px;">
                            <div>邮箱：{{ customerInfo.email }}</div>
                            <div>手机号：{{ customerInfo.phone }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding: 12px;">
                <el-tabs v-model="activeTab" @tab-click="clickTab">
                    <el-tab-pane label="跟进记录" name="zero">
                        <CustomerDynamics :customerKey="customerKey" :customerType="9" :contactName="customerInfo.name" />
                    </el-tab-pane>
                    <el-tab-pane label="线索详情" name="first">
                        <div v-for="(value,key) in clueJson" class="clueItem">
                            <div class="label">{{ key }}:</div>
                            <div v-if="key.startsWith('图片')">
                                <el-image :src="value" :preview-src-list="[value]" style="width: 100px; height: 100px;" />
                            </div>
                            <div v-else-if="key.startsWith('视频')">
                                <video :src="value" style="width: 400px; height: 240px;" controls></video>
                            </div>
                            <div class="value" v-else>{{ value }}</div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="WhatsApp" name="second" lazy>
                        <iframe v-if="msgUrl" :src="msgUrl" style="width: 100%; height: calc(100vh - 200px); border: none;"></iframe>
                        <el-empty v-else description="暂无数据"></el-empty>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-drawer>


        <el-dialog title="新增阶段" :visible.sync="phaseVisible" width="450px">
            <div style="display: flex;gap: 10px;">
                <el-input v-model="phaseName" clearable size="small"></el-input>
                <el-button type="primary" :loading="btnLoading" :disabled="!phaseName.trim()" size="small" @click="addPhaseOk">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="设置提醒" :visible.sync="tipVisible" width="450px">
            <p style="margin-bottom: 12px;line-height: 24px;color: #999;">设置完提醒后系统会定期发送邮件提醒新增的线索数量</p>
            <div style="display: flex;gap: 10px;">
                <el-input v-model="tipEmail" placeholder="邮箱" clearable size="small"></el-input>
                <el-button type="primary" :loading="btnLoading" :disabled="!tipEmail.trim()" size="small" @click="setTipOk">确 定</el-button>
            </div>
        </el-dialog>


        <NewCustomerDialog v-if="newCustomerVisible" :dialogType="1" :newCustomerVisible="newCustomerVisible" :newCustomer="newCustomer" :groupOption="privateGroupOption" :inquiryKey="inquiryKey" @closedialog="newCustomerVisible = false;" @newCustomerComplete="newCustomerComplete"></NewCustomerDialog>

    </el-card>
</template>

<script>
// import dayjs from 'dayjs';
import CustomerDynamics from "@/components/CustomerDynamics.vue"; //客户动态
import NewCustomerDialog from "../CustomerManage/components/NewCustomerDialog.vue";
export default {
    components: { CustomerDynamics, NewCustomerDialog },
    data() {
        return {
            isAdmin: false,
            isDemoAccount: false,
            userInfo: {},
            //公海线索列表
            publicCountryOption: [],
            pageType: "公海",
            public_search: {
                "country": "",
                "industry": "",
                "product": "",
                "company": "",
                "isPhone": false,
                "isEmail": false,
                "date": 0,
                "ownerKey": "",
            },
            public_adList: [],
            public_totalItems: 0,
            public_pageIndex: 1,
            public_pageSize: 10,
            //公海详情面板
            detailsVisible: false,
            detailsInfo: {
                imgUrl: [],
                videoUrl: [],
            },
            //公海跟进询盘列表
            follow_search: {
                "country": "",
                "industry": "",
                "product": "",
                "company": "",
                "isPhone": false,
                "isEmail": false,
                "date": 0,
                "ownerKey": "",
            },
            follow_adList: [],
            follow_totalItems: 0,
            follow_pageIndex: 1,
            follow_pageSize: 10,
            followVisible: false,
            //私海线索列表
            searchForm: {
                "adname": "",
                "adsetName": "",
                "campaignName": "",
                "formName": "",
                "platform": "",
                "name": "",
                "phone": "",
                "email": "",
                "country": "",
                "stutas": null,
                "ownerKey": "",
                "phase": null,
                "startDate": "", //dayjs().subtract(30, 'days').format('YYYY-MM-DD')
                "endDate": "",   //dayjs().format('YYYY-MM-DD')
            },
            advertisingList: [],
            tableLoading: false,
            totalItems: 0,
            pageIndex: 1,
            pageSize: 10,
            btnLoading: false,
            //分配线索
            allocateVisible: false,
            allocateForm: {},
            formOption: [],
            countryOption: window.ContryList,
            staffOption: [],
            industryOption: [],
            industryNumber: 0,
            //阶段修改
            allPhaseOption: [],
            basePhaseOption: [],
            phaseTotalNum: 0,
            phaseVisible: false,
            phaseName: "",
            //私海详情面板
            panelVisible: false,
            customerKey: "",
            customerInfo: {},
            clueJson: {},
            activeTab: "zero",
            msgUrl: "",
            //加入我的客户
            newCustomerVisible: false,
            newCustomer:{
                presetFormContact:{
                    "key": "",
                    "companyKey": "",
                    "isMain": true,
                    "nickname": "",
                    "email": "",
                    "workRank": "",
                    "position": "",
                    "call": "",
                    "linkedin": "",
                    "twitter": "",
                    "gender": "",
                    "birthday": "",
                    "note": "",
                    "images": [ ]
                },
                form:{
                    "companyKey": "",
                    "companyNo": "",
                    "name": "",
                    "nickname": "",
                    "customerSourceKey": "",
                    "mainIndustryValue": "",
                    "mainBusinessTypeValue": "",
                    "companyScaleValue": "少于59人",
                    "country": "",
                    "timeZone": "",
                    "star": 0,
                    "webSite": "",
                    "fax": "",
                    "areaCodeValue": "",
                    "call": "",
                    "address": "",
                    "contacters": [],
                    "privateGroupKey": "",
                    "publicGroupKey": "",
                    "statuKey": "",
                    "tags": [],
                    "note": ""
                },
            },
            privateGroupOption: [],
            inquiryKey: "",
            //设置提醒
            tipVisible: false,
            tipEmail: "",
            feiShuHook: "",
        };
    },
    methods: {
        //公海线索列表
        viewHighseas(){
            this.pageType = "公海";
            this.searchForm.phase = null;
            //获取公海线索列表
            this.public_pageIndex = 1;
            this.getPublicPage();
            //获取公海跟进询盘列表
            this.follow_pageIndex = 1;
            this.getFollowInquiry();
        },
        getPublicPage(){
            this.tableLoading = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Phase/PublicPage`, {
                ...this.public_search,
                pageIndex: this.public_pageIndex,
                pageSize: this.public_pageSize,
            }).then((res) => {
                const { isSuccess, data } = res;
                this.tableLoading = false;
                if (isSuccess) {
                    this.public_adList = data.datas.map(item=>({
                        ...item,
                        flagUrl: window.getFlagUrlByCountry?window.getFlagUrlByCountry(item.country):'',
                        ownerKey: "",
                    }))
                    this.public_totalItems = data.totalItems;
                }
            });
        },
        onPublicSearch() {
            this.public_pageIndex = 1;
            this.getPublicPage();
        },
        publicPageIndexChange(page) {
            this.public_pageIndex = page;
            this.getPublicPage();
        },
        publicPageSizeChange() {
            this.public_pageIndex = 1;
            this.getPublicPage();
        },
        addMyClue(row){
            if(this.isDemoAccount) {
                this.$message({ message: "演示账号无操作权限!", type: 'warning' });
                return;
            }
            this.$confirm('是否加入我的询盘?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Phase/AddMyInquiry`, {
                    inquirys: [row],
                    toUkey: this.userInfo.uKey,
                }).then((res) => {
                    const { isSuccess, data } = res;
                    if (isSuccess && data) {
                        this.detailsVisible = false;
                        this.$message({ message: "添加成功", type: 'success' });
                        this.getPublicPage();
                    }
                });
            }).catch(() => {});
        },
        allocateClue(value,row){
            if(this.isDemoAccount) {
                this.$message({ message: "演示账号无操作权限!", type: 'warning' });
                return;
            }
            let aItem = this.staffOption.filter(item=> item.key === value);
            let name = aItem.length > 0 ? aItem[0].name : value;
            this.$confirm(`是否分配给 ${name}?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Phase/AddMyInquiry`, {
                    inquirys: [row],
                    toUkey: value,
                }).then((res) => {
                    const { isSuccess, data } = res;
                    if (isSuccess && data) {
                        this.$message({ message: "分配成功", type: 'success' });
                        this.getPublicPage();
                    }
                });
            }).catch(() => {});
        },
        //公海详情面板
        openDetails(row) {
            if(this.isDemoAccount) return;
            this.detailsVisible = true;
            this.detailsInfo = row;
        },
        //获取公海跟进询盘列表
        getFollowInquiry(){
            this.tableLoading = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/RecordPage`, {
                ...this.follow_search,
                pageIndex: this.follow_pageIndex,
                pageSize: this.follow_pageSize,
            }).then((res) => {
                const { isSuccess, data } = res;
                this.tableLoading = false;
                if (isSuccess) {
                    this.follow_adList = data.datas.map(item=>({
                        ...item,
                        flagUrl: window.getFlagUrlByCountry?window.getFlagUrlByCountry(item.country):'',
                        ownerKey: "",
                    }))
                    this.follow_totalItems = data.totalItems;
                }
            });
        },
        onFollowSearch(){
            this.follow_pageIndex = 1;
            this.getFollowInquiry();
        },


        //获取线索列表
        getList() {
            this.tableLoading = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Page`, {
                ...this.searchForm,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
            }).then((res) => {
                const { isSuccess, data } = res;
                this.tableLoading = false;
                if (isSuccess) {
                    this.advertisingList = data.datas.map(item=>({
                        ...item,
                        flagUrl: window.getFlagUrlByCountry?window.getFlagUrlByCountry(item.country):'',
                    }))
                    this.totalItems = data.totalItems;
                }
            });
        },
        pageIndexChange(page) {
            this.pageIndex = page;
            this.getList();
        },
        pageSizeChange() {
            this.pageIndex = 1;
            this.getList();
        },
        onSearch() {
            this.pageIndex = 1;
            this.getList();
        },
        onReset(){
            this.searchForm = {
                "adname": "",
                "adsetName": "",
                "campaignName": "",
                "formName": "",
                "platform": "",
                "name": "",
                "phone": "",
                "email": "",
                "country": "",
                "stutas": null,
                "ownerKey": "",
                "phase": "",
                "startDate": "",
                "endDate": "",
            }
            this.onSearch();
        },


        //分配线索
        toAllocate() {
            this.allocateVisible = true;
            this.allocateForm = {
                formId: "",
                country: "",
                platform: "",
                ukey: "",
            };
        },
        allocateComplete() {
            const { country, ukey } = this.allocateForm; 
            if(!country) {
                this.$message({ message: "请选择国家!", type: 'warning' })
                return false;
            }
            if(!ukey) {
                this.$message({ message: "请选择分配的员工!", type: 'warning' })
                return false;
            }
            this.btnLoading = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/SetAllocation`, this.allocateForm).then((res) => {
                const { isSuccess, data } = res;
                this.btnLoading = false;
                this.allocateVisible = false;
                if (isSuccess && data) {
                    this.$message({ message: "分配成功", type: 'success' });
                    this.getList();
                }
            });
        },

        //阶段配置
        getPhases(){
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/Phases`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.allPhaseOption = data;
                    this.phaseTotalNum = data.reduce((total,item)=>{
                        return total + item.count;
                    },0);
                    this.basePhaseOption = data.filter(item=>item.name !== '垃圾-客户');
                }
            });
        },
        choosePhase(name){
            if(this.searchForm.phase === name) return;
            this.pageType = "私海";
            this.searchForm.phase = name;
            this.onSearch();
        },
        addPhase(){
            this.phaseVisible = true;
            this.phaseName = "";
        },
        addPhaseOk(){
            this.btnLoading = true;
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/Phase/Save?phaseName=${this.phaseName}`).then((res) => {
                const { isSuccess, data } = res;
                this.btnLoading = false;
                if (isSuccess && data) {
                    this.$message({ message: "添加成功", type: 'success' });
                    this.phaseVisible = false;
                    this.getPhases();
                }
            });
        },
        delPhase(key){
            this.$confirm('是否删除该阶段?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get(`${this.$customerUrl}/AdvertisingForm/Phase/Delete?key=${key}`).then((res) => {
                    const { isSuccess, data } = res;
                    if (isSuccess && data) {
                        this.$message({ message: "删除成功", type: 'success' });
                        this.getPhases();
                    }
                });
            }).catch(() => {});
        },



        //单个员工分配线索
        allocateChange(value,key){
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/UpdateOwner?key=${key}&ukey=${value}`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess && data) {
                    this.$message({ message: "分配成功", type: 'success' });
                }
            });
        },
        //单个员工设置阶段
        phaseChange(value,key){
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/UpdatePhase?key=${key}&phase=${value}`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess && data) {
                    this.$message({ message: "修改成功", type: 'success' });
                    this.getPhases();
                }
            });
        },


        //私海详情面板
        displayPanelOne(item){
            this.panelVisible = true;
            this.customerKey = item.key;
            this.customerInfo = item;
            this.clueJson = JSON.parse(item.json);
            this.clueJson['来源'] = item.formName;
            this.clueJson['提交时间'] = item.createdTime;
        },
        displayPanelTwo(item){
            this.panelVisible = true;
            this.customerKey = item.advertisingFormKey;
            this.customerInfo = item;
            this.clueJson = JSON.parse(item.json);
            this.clueJson['来源'] = item.source;
            this.clueJson['提交时间'] = item.inquiryDate;
        },
        closePanel(){
            this.panelVisible = false;
            this.customerKey = "";
            this.customerInfo = {};
            this.clueJson = {};
            this.activeTab = "zero";
        },
        clickTab(tab){
            if(tab.name == "second"){
                this.msgUrl = "";
                let wa = this.customerInfo.phone;
                if(!wa) return;
                this.$axios.post(`${this.$customerUrl}/WhatsApp/V2/MsgUrl`,{
                    key: this.customerKey,
                    wa: wa,
                }).then((res) => {
                    const { isSuccess, data } = res;
                    if (isSuccess) {
                        this.msgUrl = data;
                    }
                });
            }
        },


        //加入我的客户
        addCustomer(row){
            this.newCustomerVisible = true;
            this.inquiryKey = row.key;
            this.getGroupList();
            this.newCustomer.form.name = row.company;
            this.newCustomer.form.country = row.country;
            this.newCustomer.presetFormContact.nickname = row.name;
            this.newCustomer.presetFormContact.email = row.email;
            this.newCustomer.presetFormContact.call = row.phone;
        },
        async getGroupList() {
            try {
                const res = await this.$axios({
                    method: "GET",
                    url: this.$customerUrl + "/v1/Config/PrivateGroup",
                });
                this.privateGroupOption = res.data || [];
                this.newCustomer.form.privateGroupKey = res.data.filter(ele=>ele.isDefault)[0]?.key??"";
            } catch {
                this.privateGroupOption = [];
            }
        },
        newCustomerComplete(){
            this.newCustomerVisible = false;
            this.getList();
        },

        //删除线索
        delClue(key){
            this.$confirm('是否删除该线索?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get(`${this.$customerUrl}/AdvertisingForm/Delete?key=${key}`).then((res) => {
                    const { isSuccess, data } = res;
                    if (isSuccess && data) {
                        this.$message({ message: "删除成功", type: 'success' });
                        this.getList();
                    }
                });
            }).catch(() => {});
        },


        //获取所有成员集合
        getStaff(){
            return new Promise((resolve, reject) => {
                this.$axios.get(`${this.$personnelUrl}/Organization/FindStaffBox`).then((res) => {
                    const { isSuccess, data } = res;
                    if (isSuccess) {
                        resolve(data);
                    }
                })
            })
        },
        //获取表单下拉框
        getFormBox(){
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/FormBox`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.formOption = data;
                }
            });
        },

        //获取行业下拉框
        getIndustryBox(){
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/V2/PublicIndustry`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.industryNumber = data.length;
                    this.industryOption = [
                        {
                            key: "yes",
                            label: "",
                            options: data.filter(ele=>ele.disable==false)
                        },
                        {
                            key: "no",
                            label: "",
                            options: data.filter(ele=>ele.disable==true)
                        }
                    ];

                }
            });
        },

        isReadDetail(){
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/Public/ReadDetail`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    //演示账号禁用:查看详情/分配人员/加入询盘;
                    this.isDemoAccount = !data;
                }
            });
        },

        //设置提醒
        setTip(){
            this.tipVisible = true;
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/GetPushConfig`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.feiShuHook = data.feiShuHook || "";
                    this.tipEmail = data.email || "";
                }
            });
        },
        setTipOk(){
            this.btnLoading = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/SavePushConfig`,{
                feiShuHook: this.feiShuHook,
                email: this.tipEmail
            }).then((res) => {
                const { isSuccess, data } = res;
                this.btnLoading = false;
                if (isSuccess && data) {
                    this.tipVisible = false;
                    this.$message({ message: "设置成功", type: 'success' });
                }
            });
        },


        //获取公海国家配置
        getPublicCountry(){
            this.$axios.get(`${this.$customerUrl}/AdvertisingForm/PublicCountry`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.publicCountryOption = data.map(item=>({
                        ...item,
                        flagUrl: window.getFlagUrlByCountry?window.getFlagUrlByCountry(item.label):'',
                    }))
                }
            });
        },


    },
    mounted() {
        this.userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {},
        this.isAdmin = this.userInfo.isAdmin || false;
        
        this.pageType = this.$route.query.private ? "私海" : "公海";
        
        this.getPhases();
        this.getStaff().then((data) => {
            this.staffOption = data;
            // this.getList();
            if(this.pageType === "公海"){
                this.viewHighseas();
            } else {
                this.choosePhase('');
            }
        })
        this.getFormBox();
        this.getIndustryBox();
        this.isReadDetail();
        this.getPublicCountry();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__header{
    padding: 10px 20px;
}
::v-deep .el-card__body{
    padding: 0;
}
::v-deep .el-dialog__body{
    padding: 10px 20px 20px;
}
.clearfix{
    display: flex;
    align-items: center;
    height: 32px;
    .title{
        font-size: 18px;
        font-weight: bold;
        width: 160px;
    }
}
.searchItem {
    width: 200px;
}

.ellipsis{
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.leftFilter{
    width: 180px;
    height: calc(100vh - 182px);
    border-right: 1px solid #ebeef5;
    .title{
        font-size: 14px;
        font-weight: bold;
        padding: 0 12px;
        margin-bottom: 12px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        .el-icon-plus{
            cursor: pointer;
            font-size: 16px;
        }
    }
    .activeTitle{
        color: #fff;
        background-color: var(--themeColor);
    }
    .phaseItem{
        padding: 0 12px;
        margin-bottom: 6px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        .el-icon-delete{
            display: none;
        }
        &:hover .el-icon-delete{
            display: inline-block;
            
        }
    }
    .activePhase{
        color: #fff;
        background-color: var(--themeColor);
    }
}

.rightContent{
    width: calc(100% - 180px);
    padding: 12px;
    box-sizing: border-box;
    height: calc(100vh - 182px);
    overflow: auto;
}

.clueItem{
    line-height: 28px;
    word-break: break-all;
    margin-bottom: 10px;
    border-bottom: 1px solid #c9c9c9;
    .label{
        color: #9a9a9a;
        font-size: 14px;
    }
    .value{
        color: #333;
        font-size: 16px; 
    }
}

.public_ad_item{
    display: flex;
    border-bottom: 1px solid #DDE0E9;
    padding: 8px;
    margin-bottom: 12px;
    .rightInfo{
        width: calc(100% - 112px);
        margin-left: 12px;
        flex: auto;
        display: flex;
    }
    .fieldItem{
        display: flex;
        align-items: center;
        width: 100%;
        gap: 4px;
        .fieldlabel{
            min-width: 32px;
            font-size: 14px;
            color: #9a9a9a;
        }
        .fieldvalue{
            font-size: 14px;
            color: #333;
        }
    }
    &:last-child{
        margin-bottom: 0;
    }
}

.abtitle{
    display: flex;
    align-items: center;
    height: 24px;
    font-size: 14px;
    color: #353B4D;
    margin-bottom: 6px;
    margin-top: 12px;
    &::before{
        content: "";
        display: inline-block;
        width: 2px;
        height: 12px;
        background-color: var(--themeColor);
        border-radius: 2px;
        margin-right: 8px;
    }
}
.abItem{
    display: flex;
    line-height: 24px;
    word-break: break-all;
    margin-bottom: 6px;
    .label{
        min-width: 32px;
        font-size: 14px;
        color: #9a9a9a;
        margin-right: 10px;
    }
    .value{
        color: #333;
        font-size: 16px;
    }
}
</style>